import pkgJson from '../../../../package.json';

export const environment = {
  production: true,
  app_version: pkgJson.version,

  auth0_domain: 'login.besmarthead.com',
  auth0_clientId: 'XDUWdmcRSrP7BdlwmVQXDnognHsgV28a',
  auth0_custom_claims_prefix: 'https://login.besmarthead.com/',

  api_smarthead_base_path: 'https://api-v3.besmarthead.com',
  api_smarthead_v2_base_path: 'https://api-v2.besmarthead.com',
  api_link_shortener_base_path: 'https://sh.besmarthead.com',

  // cookie
  cookies_secure: true,

  // froala licence
  froalaKey: 'SpvgxwelqC-7zxB5B-16pm==',

  // link shortener domain
  shDomain: 'https://wwww.besmarthead.com',

  // link shortener domain
  linkShortenerDomain: 'https://sh.besmarthead.com'
};
